<template>
  <div data-scroll-container id="scroll-container">

    <slot />
  </div>
</template>

<script>

import LocomotiveScroll from "locomotive-scroll";
export default {
  name: "SmoothScroll",
  data() {
    return {
      Loco: "",

      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      scrolled: 0,

    };
  },
  created: function () {

    window.addEventListener("resize", this.resizeHandler)
    window.addEventListener("resize", this.update_on_resize)

  },
  mounted() {

    if (this.windowWidth <= 1023) {
      window.addEventListener("scroll", () => {
        let _h = document.querySelector(".header-wrapper.scrolled");
        window.pageYOffset < this.scrolled && window.pageYOffset > 1000 ? _h.classList.remove("hide") : _h.classList.add("hide");

        this.scrolled = window.pageYOffset;
      })

    }

    this.$nextTick(
      function () {

        this.initLoco();

        this.Loco.on('scroll', (e) => {

          if (this.windowWidth >= 1024) {
            let _h = document.querySelector(".header-wrapper.scrolled");
            e.scroll.y < this.scrolled && e.scroll.y > 900 ? _h.classList.remove("hide") : _h.classList.add("hide");

            this.scrolled = e.scroll.y;
          }


        })



      })



  },
  computed: {
    updateOnLoad() {
      return this.$store.state.main.current_content_request_status;
    },
    update_trigger() {
      return this.$store.state.main.trigger_update;
    },
    stop_scroll() {
      return this.$store.state.main.stop_scroll;
    },
    scroll_to_conf() {
      return this.$store.state.main.scrollTo_conf;
    }



  },
  watch: {
    Loco: {
      immediate: true,
      handler(ns, os) {
        this.$store.state.main.smooth_scroll = ns;
      }
    },
    stop_scroll(ns, os) {
      if (ns === true) {
        this.Loco.stop();
        // console.log('stoooooop')
      } else {
        this.Loco.start();
        // console.log('ruuuuuun')

      }
    },
    '$route'(ns, os) {
      // this.windowWidth >= 1024 ?  this.Loco.scrollTo(0,0) : window.scrollTo(0,0);
      if (this.windowWidth >= 1024) {
        this.Loco.scrollTo("top", {
          duration: 0,
          disableLerp: true,
        });
        // this.Loco.offset
      }




      else if (this.windowWidth <= 1023) {

        // window.scrollTo(document.querySelector('#configurator'));
        window.scrollTo(0, 0);



      }
    },
    windowHeight: {
      immediate: true,
      handler(newVal, oldVal) {
        this.windowHeight = newVal;
        this.resizeHandler();

      }
    },
    windowWidth: {
      immediate: true,
      handler(newVal, oldVal) {
        this.windowWidth = newVal;
        this.resizeHandler();

      }
    },
    scroll_to_conf(ns, os) {
      setTimeout(() => {
        this.Loco.scrollTo(document.querySelector('#configurator'));

      }, 600);
    },
    updateOnLoad: {
      immediate: true,
      handler(newState, oldState) {
        if (newState === 'done') {
          setTimeout(() => {
            this.Loco.update();

          }, 600);

        }
      }

    },





    update_trigger(newState, oldState) {


      setTimeout(() => {

        this.Loco.update();

      }, 501);


    }
  },
  methods: {
    resizeHandler() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;

    },
    update_on_resize() {
      this.Loco.update();
    },
    initLoco() {
      this.Loco = new LocomotiveScroll({
        el: document.querySelector("[data-scroll-container]"),
        direction: "vertical",

        multiplier: 1.1,
        smooth: true,
        touchMultiplier: 2,
        gestureDirection: 'vertical',
        tablet: {
          smooth: true,
          direction: "vertical",
          breakpoint: 1024,
        },
        smartphone: {
          breakpoint: 767,
          smooth: false,
          direction: "vertical",
        },
      });
      this.$store.state.main.loco = this.Loco;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.update_on_resize);
    this.Loco.destroy();
  }
};
</script>



<style lang="scss">
.fade2-enter-active,
.fade2-leave-active {
  transition-duration: .5s;
  transition-property: opacity;
  transition-timing-function: ease;
  opacity: 1;
}

// .fade2-enter-active {
//   transition-delay: .7s;
// }

.fade2-enter,
.fade2-leave-active {
  opacity: 0;
}
</style>
